import React, { useEffect } from "react";
import Router from "../router";
import { RouterProvider } from "react-router-dom";
import Loader from "../components/new/Loader";
import NewRelic from "../utility/newRelic";
import useCache from "../hooks/useCache";
import { getSettingsStorage, settingsHandler } from "../utility/settings.utils";

const App = () => {
    useEffect(async () => {
        if (!localStorage.getItem("settings")) await settingsHandler();
        const companyInfo = getSettingsStorage("company_info");
        if (companyInfo?.company_id) {
            document.title = companyInfo?.title?.en;
        }
    }, []);
    useCache();
    return <RouterProvider router={Router} fallbackElement={<RouteLoader />} />;
};

const RouteLoader = () => {
    return (
        <div className="relative" style={{ height: "100dvh" }}>
            {process.env.MIX_REACT_APP_NEW_RELIC_ENABLED === "true" ||
            process.env.MIX_REACT_APP_NEW_RELIC_ENABLED === true ? (
                <NewRelic />
            ) : null}
            <Loader />
        </div>
    );
};

export default App;
